/**
 * Parses chart data field that can be a string (single or double JSON stringified) or an object.
 *
 * @param {string|object|null|undefined} dataField - The data field to parse
 * @returns {object|null} - Parsed data object or null if parsing fails
 */
export function parseChartData(dataField) {
    if (!dataField) {
        return null;
    }

    try {
        if (typeof dataField === 'string') {
            const firstParse = JSON.parse(dataField);

            if (typeof firstParse === 'string') {
                return JSON.parse(firstParse);
            } else {
                return firstParse;
            }
        } else if (typeof dataField === 'object') {
            return dataField;
        }
    } catch (error) {
        console.error('Error parsing chart data:', error, dataField);
        return null;
    }

    return null;
}
